import { render, staticRenderFns } from "./Jobdetails.vue?vue&type=template&id=66df06c6&"
import script from "./Jobdetails.vue?vue&type=script&lang=ts&"
export * from "./Jobdetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports